import { Link, useNavigate, useParams } from "react-router-dom";
import logo from "../../assets/logos/BI Logo.png";
import styles from "./MfaSignin.module.css";
import { SignupContext } from "../../contexts/auth/signup-ctx";
import {
  ChangeEvent,
  KeyboardEvent,
  RefObject,
  useContext,
  useRef,
} from "react";
import { useMutation } from "@tanstack/react-query";
import { postMfaSignin } from "../../http/auth.http";
import { AuthContext } from "../../contexts/auth/auth-ctx";
import { UserType } from "../../types/user";
import Spinner from "../ui/progress/Spinner";
import { UiContext } from "../../contexts/ui/ui-ctx";

const MfaSignin = () => {
  const authCtx = useContext(AuthContext);
  const uiCtx = useContext(UiContext);
  const { token } = useParams();
  const navigate = useNavigate();
  const { mutate, isPending } = useMutation({
    mutationFn: postMfaSignin,
    onSuccess: (data) => {
      authCtx.login(data.token, data.user as UserType);
      console.log("Data: ", data);
      navigate("/dashboard", { replace: true });
    },

    onError: () => {
      uiCtx.showNewNotification("error", "Invalid token");
    },
  });

  const code1Ref = useRef<HTMLInputElement>(null);
  const code2Ref = useRef<HTMLInputElement>(null);
  const code3Ref = useRef<HTMLInputElement>(null);
  const code4Ref = useRef<HTMLInputElement>(null);
  const code5Ref = useRef<HTMLInputElement>(null);
  const code6Ref = useRef<HTMLInputElement>(null);

  const signupCtx = useContext(SignupContext);

  const handleCodeChange = (
    e: ChangeEvent<HTMLInputElement>,
    nextRef: RefObject<HTMLInputElement> | null
  ) => {
    // Get the current value
    const value = e.target.value;

    if (value.length === 1) {
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  const handleKeyDown = (
    e: KeyboardEvent<HTMLInputElement>,
    prevRef: RefObject<HTMLInputElement> | null
  ) => {
    if (e.key === "Backspace") {
      prevRef?.current?.focus();
    }
  };

  const submitHandler = () => {
    const codes = [
      code1Ref.current?.value,
      code2Ref.current?.value,
      code3Ref.current?.value,
      code4Ref.current?.value,
      code5Ref.current?.value,
      code6Ref.current?.value,
    ];

    if (codes.includes("")) {
      console.log("Here now...");
      return;
    }

    console.log("Here");
    const mfaCode = codes.join("");
    mutate({ code: mfaCode, token });
  };

  return (
    <div className={styles.wrapper}>
      {isPending && (
        <div className={styles["loading-wrapper"]}>
          <Spinner />
        </div>
      )}
      <img className={styles.logo} src={logo} alt="brighter investment" />

      <div className={styles.content}>
        <h3 className={styles.heading}>Verify your email address</h3>
        <p className={styles["heading-description"]}>
          {`We sent you a six-digit code to ${signupCtx.userData.email}. Enter the code below to sign in.`}
        </p>

        <ul className={styles.inputs}>
          <li>
            <input
              ref={code1Ref}
              className={styles.input}
              type="text"
              onChange={(e) => handleCodeChange(e, code2Ref)}
              onKeyDown={(e) => handleKeyDown(e, code1Ref)}
            />
          </li>
          <li>
            <input
              ref={code2Ref}
              className={styles.input}
              type="text"
              onChange={(e) => handleCodeChange(e, code3Ref)}
              onKeyDown={(e) => handleKeyDown(e, code2Ref)}
            />
          </li>
          <li>
            <input
              ref={code3Ref}
              className={styles.input}
              type="text"
              onChange={(e) => handleCodeChange(e, code4Ref)}
              onKeyDown={(e) => handleKeyDown(e, code3Ref)}
            />
          </li>
          <li>
            <input
              ref={code4Ref}
              className={styles.input}
              type="text"
              onChange={(e) => handleCodeChange(e, code5Ref)}
              onKeyDown={(e) => handleKeyDown(e, code4Ref)}
            />
          </li>
          <li>
            <input
              ref={code5Ref}
              className={styles.input}
              type="text"
              onChange={(e) => handleCodeChange(e, code6Ref)}
              onKeyDown={(e) => handleKeyDown(e, code5Ref)}
            />
          </li>
          <li>
            <input
              ref={code6Ref}
              className={styles.input}
              type="text"
              onChange={(e) => handleCodeChange(e, null)}
              onKeyDown={(e) => handleKeyDown(e, code6Ref)}
            />
          </li>
        </ul>

        <p className={styles["did-not-request"]}>
          If you didn’t request the code, please ignore the mail.
        </p>
        <button
          className={`auth-btn ${styles.btn}`}
          type="button"
          onClick={submitHandler}
        >
          Sign in
        </button>

        <p className={styles.login}>
          Didn’t receive code? <Link to={"/auth/signin"}>Resend</Link>{" "}
          {/* // TODO: Implement resend code when clicked */}
        </p>
      </div>
    </div>
  );
};

export default MfaSignin;
